import React from 'react';
import CounterOne from '../../components/About/CounterOne';
import videoImg from '../../assets/images/resources/counter-one-img-1.jpg';

const counters = [
  { iconClass: 'icon-schedule', end: 50, suffix: '+', text: 'Projects & Productions Completed' },
  { iconClass: 'icon-schedule', end: 500, suffix: '+', text: 'Students Trained' },
  { iconClass: 'icon-schedule', end: 10, suffix: '+', text: 'Professional Studio Services' }
];

const Features = () => {
    return (
      <>
        <CounterOne
            imageSrc={videoImg}
            videoId="1QGaxcefTTw"
            videoCaption="Watch Our Production Work"
            tagline="Our Features"
            title="Creating Talent & Producing Real Content"
            description="Sunrising Cinevision is a complete creative ecosystem where learning meets real-world production. We offer professional training along with film production, podcast studio, chroma shoots, photography, and event coverage — giving you both skills and industry experience."
            counters={counters}
        />
      </>
    );
}

export default Features;